// extracted by mini-css-extract-plugin
export default {"vertical":"EventsList_vertical--x4n","card":"EventsList_card--K_Q","pagination":"EventsList_pagination--QM3"};